/* eslint-disable @next/next/no-img-element */
import React from "react";

const JobCardTags = ({ tags }) => {
	if (Array.isArray(tags) && tags?.length > 0) {
		return (
			<div
				className="scrollbarHide scrollbarHide::-webkit-scrollbar w-full overflow-x-scroll"
				data-testid="job-tags-info"
			>
				<div className="flex items-center gap-[4px]">
					{tags?.map((tag: { icon_link: string; text: string }) => (
						<div className="flex min-w-max items-center gap-[4px] rounded-sm bg-[#F2F2F3] px-[4px] text-[#827485] md:w-max">
							<img src={tag?.icon_link} height={20} width={20} alt="" />
							<p className="m-0 whitespace-nowrap text-xs text-[#8C8594]">
								{tag?.text}
							</p>
						</div>
					))}
				</div>
			</div>
		);
	}
	return null;
};

export default JobCardTags;
